import { graphql } from '@predium/client-graphql';

export const UPDATE_ORG_PREFERENCE_FOR_ECONOMIC_UNIT = graphql(`
  mutation UpdateOrgPreferenceForEconomicUnit($economicUnitEnabled: Boolean!) {
    setCommonOrgPreferences(input: { isEconomicUnitsToggled: $economicUnitEnabled }) {
      isEconomicUnitsToggled
    }
  }
`);

export const UPDATE_ORG_PREFERENCE_FOR_AUTOMATIC_ACTION_COST_UPDATE = graphql(`
  mutation UpdateOrgPreferenceForAutomaticActionCostUpdate($automaticActionCostUpdateEnabled: Boolean!) {
    setCommonOrgPreferences(input: { isAutomaticActionCostUpdateToggled: $automaticActionCostUpdateEnabled }) {
      isAutomaticActionCostUpdateToggled
    }
  }
`);

export const UPDATE_ORG_PREFERENCE_FOR_ECONOMIC_UNIT_IN_FILE_DRIVE = graphql(`
  mutation UpdateOrgPreferenceForEconomicUnitInFileDrive($economicUnitInFileDriveEnabled: Boolean!) {
    setCommonOrgPreferences(input: { isEconomicUnitsInFileDriveToggled: $economicUnitInFileDriveEnabled }) {
      isEconomicUnitsInFileDriveToggled
    }
  }
`);

export const SET_ORG_CO2_PRICE_CURVE = graphql(`
  mutation SetOrgCo2PriceCurve($input: SetOrgCo2PriceCurveInput!) {
    setOrgCo2PriceCurve(input: $input) {
      kind
      growthStartValue
      growthAnnualPercent
      anchors {
        year
        pricePerTon
      }
    }
  }
`);

export const SET_ORG_EU_TAXONOMY_DATASOURCE = graphql(`
  mutation SetOrgEuTaxonomyDatasource($input: SetOrgEuTaxonomyDatasourceInput!) {
    setOrgEuTaxonomyDatasource(input: $input) {
      euTaxonomyDatasource
    }
  }
`);

export const SET_ORG_EMISSION_FACTOR_PREFERENCES = graphql(`
  mutation SetOrgEmissionFactorPreferences($input: SetOrgEmissionFactorPreferencesInput!) {
    setOrgEmissionFactorPreferences(input: $input) {
      activeEmissionFactorPreferences {
        ... on CrremOrgPreferences {
          emissionFactorType
          crremVersion
          activeCRREMConfiguration {
            ... on CRREMDefaultConfigurationObject {
              ...CRREMDefaultConfiguration
            }
            ... on CRREMCustomConfigurationObject {
              ...CRREMCustomConfiguration
            }
          }
        }
        ... on NationalEnergyLawOrgPreferences {
          emissionFactorType
        }
      }
      availableReportingYears
    }
  }
`);

/**
 * Publishes a file whose bytes the browser PUT straight to S3 via a presigned URL. The backend
 * HEADs the object before clearing `uploading`, so a failed transfer leaves the row hidden.
 *
 * The only way to clear `uploading` from the client — the column is no longer writable through
 * Hasura by USER / ORG_ADMIN.
 */
export const CONFIRM_FILE_UPLOAD = graphql(`
  mutation ConfirmFileUpload($fileId: Int!, $fileName: String) {
    confirmFileUpload(input: { fileId: $fileId, fileName: $fileName }) {
      fileId
      name
    }
  }
`);
